import React, { useEffect, useId, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './warehouse-name-tooltip.css';

export default function WarehouseNameTooltip({ name, children }) {
  const id = useId();
  const tooltip = useRef(null);
  const [anchor, setAnchor] = useState(null);
  const [position, setPosition] = useState(null);
  const close = () => setAnchor(null);
  function show(event) {
    const rect = event.currentTarget.getBoundingClientRect();
    setPosition(null);
    setAnchor(event.type === 'mouseenter'
      ? { left: event.clientX + 12, top: event.clientY + 14 }
      : { left: rect.left, top: rect.bottom + 6 });
  }
  useLayoutEffect(() => {
    if (!anchor || !tooltip.current) return;
    const rect = tooltip.current.getBoundingClientRect();
    setPosition({
      left: Math.max(8, Math.min(anchor.left, window.innerWidth - rect.width - 8)),
      top: Math.max(8, Math.min(anchor.top, window.innerHeight - rect.height - 8)),
    });
  }, [anchor, name]);
  useEffect(() => {
    if (!anchor) return undefined;
    const dismiss = event => { if (event.key === 'Escape') setAnchor(null); };
    const hide = () => setAnchor(null);
    document.addEventListener('keydown', dismiss);
    window.addEventListener('scroll', hide, true);
    window.addEventListener('resize', hide);
    return () => {
      document.removeEventListener('keydown', dismiss);
      window.removeEventListener('scroll', hide, true);
      window.removeEventListener('resize', hide);
    };
  }, [anchor]);
  if (!name) return children;
  return <>{React.cloneElement(children, {
    title: undefined,
    'aria-describedby': [children.props['aria-describedby'], anchor ? id : null].filter(Boolean).join(' ') || undefined,
    onMouseEnter: event => { children.props.onMouseEnter?.(event); show(event); },
    onMouseLeave: event => { children.props.onMouseLeave?.(event); close(); },
    onFocus: event => { children.props.onFocus?.(event); show(event); },
    onBlur: event => { children.props.onBlur?.(event); close(); },
  })}{anchor && createPortal(<div ref={tooltip} id={id} role="tooltip" className="warehouse-name-tooltip" style={position || anchor}>{name}</div>, document.body)}</>;
}
